export enum DocumentsTypes {
    GET_DOCUMENTS = '@@documents/GET_DOCUMENTS',
    GET_DOCUMENTS_SUCCESS = '@@documents/GET_DOCUMENTS_SUCCESS',
    GET_DOCUMENTS_FAIL = '@@documents/GET_DOCUMENTS_FAIL',
  
    GET_ONE_DOCUMENT = '@@documents/GET_ONE_DOCUMENT',
    GET_ONE_DOCUMENT_SUCCESS = '@@documents/GET_ONE_DOCUMENT_SUCCESS',
    GET_ONE_DOCUMENT_FAIL = '@@documents/GET_ONE_DOCUMENT_FAIL',


    GET_DOCUMENTS_INNOBO_DOCS = '@@documents/GET_DOCUMENTS_INNOBO_DOCS',
    GET_DOCUMENTS_SUCCESS_INNOBO_DOCS = '@@documents/GET_DOCUMENTS_SUCCESS_INNOBO_DOCS',
    GET_DOCUMENTS_FAIL_INNOBO_DOCS = '@@documents/GET_DOCUMENTS_FAIL_INNOBO_DOCS',
  
    UPLOAD_DOCUMENT_INNOBO_DOCS = '@@documents/UPLOAD_DOCUMENT_INNOBO_DOCS',
    UPLOAD_DOCUMENT_SUCCESS_INNOBO_DOCS = '@@documents/UPLOAD_DOCUMENT_SUCCESS_INNOBO_DOCS',
    UPLOAD_DOCUMENT_FAIL_INNOBO_DOCS = '@@documents/UPLOAD_DOCUMENT_FAIL_INNOBO_DOCS',

    DELETE_DOCUMENT_INNOBO_DOCS = '@@documents/DELETE_DOCUMENT_INNOBO_DOCS',
    DELETE_DOCUMENT_SUCCESS_INNOBO_DOCS = '@@documents/DELETE_DOCUMENT_SUCCESS_INNOBO_DOCS',
    DELETE_DOCUMENT_FAIL_INNOBO_DOCS = '@@documents/DELETE_DOCUMENT_FAIL_INNOBO_DOCS',
  }
  